import _ from 'lodash';
import React from 'react';
import { Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useUserContext } from '../contexts/userContext';
import { GenericModelTable } from '../components';

const StyledChip = withStyles({
	colorPrimary: {
		backgroundColor: '#2e7d32'
	},
	colorSecondary: {
		backgroundColor: '#d50000'
	}
})(Chip);

function columns(user) {
	const columns = [];
	if (user.role === 'admin') {
		columns.push(
			{
				name: 'returnStatus',
				label: 'e-Return Status',
				options: {
					rawValue: true,
					filter: true,
					sort: true,
					searchable: false,
					customFilterListOptions: {
						render: v => (v ? _.startCase(_.toLower(v)) : '')
					},
					filterOptions: {
						names: ['filed', 'filing', 'not_filed'],
						renderValue: v => (v ? _.startCase(_.toLower(v)) : '')
					}
				},
				cellTemplate({ value }) {
					let color = 'primary';
					if (!value) return <></>;
					if (value === 'filing') color = 'default';
					else if (_.lowerCase(value) !== 'filed') color = 'secondary';
					return <StyledChip color={color} label={value}></StyledChip>;
				}
			},
			{
				name: 'etaReturnStatus',
				label: 'ETA Return Status',
				options: {
					rawValue: true,
					filter: true,
					sort: true,
					searchable: false,
					filterOptions: {
						names: ['Submitted', 'Valid', 'Invalid', 'Rejected', 'Cancelled']
					}
				},
				cellTemplate({ value }) {
					let color = 'secondary';
					if (!value) return <></>;
					if (value === 'Valid') color = 'primary';
					if (['Cancelled', 'Submitted'].includes(value)) color = 'default';
					return <StyledChip color={color} label={value}></StyledChip>;
				}
			}
		);
	}
	columns.push(
		{
			name: 'storeId',
			label: 'Store',
			options: { filter: true, sort: true, searchable: false }
		},
		{
			name: 'returnNumber',
			label: 'Return Number',
			options: { filter: true, sort: true, searchable: true }
		},
		{
			name: 'invoice_invoiceNumber',
			label: 'Original Invoice',
			options: { filter: false, sort: false, searchable: false }
		},
		{
			name: 'status',
			label: 'Status',
			options: { filter: true, sort: true, searchable: false }
		},
		{
			name: 'partyName',
			label: 'Party Name',
			options: { sort: true, filter: true, searchable: true }
		},
		{
			name: 'totalPrice',
			label: 'Amount',
			options: { sort: true, filter: true, searchable: false }
		},
		{
			name: 'returnDate',
			label: 'Return Date',
			options: { sort: true, filter: true, searchable: false }
		},
		{
			name: 'createdDate',
			label: 'Created Date',
			options: { sort: true, filter: true, searchable: false }
		}
	);
	return columns;
}
const modelName = 'invoicereturn';

function Invoicereturns() {
	const { user } = useUserContext();
	const tableColumns = columns(user);
	const tableOptions = {
		modelName,
		modelNamePlural: 'Invoice Returns',
		columns: tableColumns,
		tableOptions: {}
	};

	return <GenericModelTable {...tableOptions} />;
}

export default Invoicereturns;
